export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-6">关于91吃瓜</h2>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <p className="text-foreground-600 leading-relaxed mb-4">
            91吃瓜是一个专注于热点事件视频聚合与在线观看的平台，致力于为全网用户提供最新、最全、最高清的吃瓜视频内容。
            平台日均更新超过2000条视频，覆盖娱乐八卦、社会热点、网红动态、综艺内幕、影视吐槽等丰富品类。
          </p>
          <p className="text-foreground-600 leading-relaxed mb-4">
            我们以快速聚合、高清画质和清爽无广告的观看体验为核心优势，支持桌面端、移动网页端及 iOS / Android 双平台客户端，
            让每一位用户都能随时随地畅享91吃瓜在线观看的乐趣。
          </p>
          <p className="text-foreground-600 leading-relaxed">
            91吃瓜视频专区始终坚持内容为王，每日人工甄选优质视频，确保每一条推荐都值得观看。
            欢迎通过投稿渠道分享你的独家线索，让我们一起打造全网最活跃的吃瓜社区。
          </p>
        </div>
      </div>
    </section>
  );
}